import { IVR_URLS } from "../../services/apiConfig.js";
import { ACSIDENTITY_ERRORS } from "../../common/constants/ivrModule/acsConstants.js";
import apiClient from "../apiInstance.js";


export const getAgentIdentity = async () => {
    try {
        const response = await apiClient.get(IVR_URLS.GET_ACS_IDENTITY);
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const refreshAgentToken = async (acsIdentity) => {
    try {
        const response = await apiClient.post(
            IVR_URLS.REFRESH_ACS_IDENTITY_TOKEN,
            { userId: acsIdentity }
        );
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.REFRESH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};